import { render, staticRenderFns } from "./AddDisposisi.vue?vue&type=template&id=745484cf&"
import script from "./AddDisposisi.vue?vue&type=script&lang=js&"
export * from "./AddDisposisi.vue?vue&type=script&lang=js&"
import style0 from "./AddDisposisi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports